import { render } from "./AgregarPregunta.vue?vue&type=template&id=adabb10c&scoped=true"
import script from "./AgregarPregunta.vue?vue&type=script&lang=js"
export * from "./AgregarPregunta.vue?vue&type=script&lang=js"

import "./AgregarPregunta.vue?vue&type=style&index=0&id=adabb10c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adabb10c"]])

export default __exports__